<template>
  <el-card shadow="never" class="query-card">
    <el-form :inline="true" class="query_form">
      <el-form-item label="仓库" prop="inWarehouse.selected">
        <select-multiple
          ref="inWarehouse"
          class="query_form_item"
          :select-data="queryForm.inWarehouse"
          is-scroll
          :isClear="false"
          :change="inWarehouseSelect"
          suffixText="盘点中"
          @keydown.enter.right.native="inWarehouseSelect"
        ></select-multiple>
      </el-form-item>
      <el-form-item label="业务员" prop="salesman.selected">
        <select-multiple
          ref="salesman"
          class="query_form_item"
          :select-data="queryForm.salesman"
          is-scroll
          :isClear="false"
          :change="salesmanSelect"
          @keydown.enter.right.native="salesmanSelect"
          @keydown.left.native="queryFormLeftOrRight($refs.salesman, $refs.inWarehouse)"
        ></select-multiple>
      </el-form-item>
      <el-form-item label="盘点人" prop="deliverUser.selected">
        <select-multiple
          ref="deliverUser"
          class="query_form_item"
          :select-data="queryForm.deliverUser"
          is-scroll
          :isClear="false"
          :change="deliverUserSelect"
          @keydown.enter.right.native="deliverUserSelect"
          @keydown.left.native="queryFormLeftOrRight($refs.deliverUser, $refs.salesman)"
        ></select-multiple>
      </el-form-item>
      <el-form-item label="备注" prop="remark.selected">
        <el-input
          ref="remark"
          class="query_form_item"
          v-model.trim="queryForm.remark.selected"
          :placeholder="queryForm.remark.placeholder"
          @change="remarkChange"
          @keydown.enter.right.native="remarkChange"
          @keydown.left.native="queryFormLeftOrRight($refs.remark, $refs.deliverUser)"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input placeholder="输入商品名称或条码搜索" v-model="searchInput" clearable @keydown.enter.native="tableFilter">
          <el-button slot="append" @click="tableFilter">搜索</el-button>
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-dropdown v-if="power.activeName.match(/third/i)" placement="bottom-start" @command="beginInventory">
          <el-button type="primary">
            生成单据<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="C" :disabled="power.tag == 'edit' ? true : false">生成盘点单</el-dropdown-item> -->
            <!-- <el-dropdown-item command="D" :disabled="power.tag == 'edit' ? true : false">生成盘空单</el-dropdown-item> -->
            <!-- <el-dropdown-item command="E" :disabled="power.tag == 'edit' ? true : false">excel导入盘点单</el-dropdown-item> -->
            <el-dropdown-item command="F" :disabled="power.tag == 'edit' ? true : false">加载有库存商品</el-dropdown-item>
            <el-dropdown-item command="G" :disabled="power.tag == 'edit' ? true : false">加载全部商品</el-dropdown-item>
            <el-dropdown-item command="H" :disabled="power.tag == 'edit' ? true : false">生成盘空单</el-dropdown-item>
            <el-dropdown-item command="I" :disabled="power.tag == 'edit' ? true : false">excel导入有库存商品</el-dropdown-item>
            <el-dropdown-item command="J" :disabled="power.tag == 'edit' ? true : false">excel导入全部商品</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <el-form-item v-if="power.activeName.match(/first|third|fourth/i)">
        <el-button type="primary" @click="batchEnterInventory">批量录入</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="toJump">订单占用查询</el-button>
      </el-form-item>
    </el-form>
    <el-dialog :visible.sync="selectProductVisible" width="1080px" :close-on-click-modal="false" custom-class="product-dialog">
      <selectProduct v-if="selectProductVisible" @get-product-data="getProductData" :args="{ tag: 'PKD', warehouseID: queryForm.inWarehouse.selected.value }" :default-checked-keys="defaultCheckedKeys" :default-disabled-keys="defaultDisabledKeys"></selectProduct>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="dialogImportVisible" width="400px" @close="dialogImportColse">
      <template>
        <import-template
          :downloadTemplateURL="`/erpnew/account/c/reada46ceb/export/inventoryItem?warehouseID=${ queryItem.warehouse.value }&searchType=${searchType}&invCheckWay=C`"
          downloadTemplateName="盘点单导出模板"
          :isNew="true"
          :importExcelURL="`/erpnew/account/c/reada46ceb/import/inventoryItem?warehouseID=${ queryItem.warehouse.value }&searchType=${searchType}&invCheckWay=C`"
        >
        </import-template>
      </template>
    </el-dialog>
  </el-card>
</template>

<script>
import selectProduct from '@/components/common/selectProduct.vue'
import importTemplate from '@/components/common/importTemplate.vue'
import { getResultArray } from '@/assets/js/common.js'
import { queryFormLeftOrRight } from '@/assets/js/orderEntering.js'
export default {
  props: {
    power: Object,
    billNo: String
  },
  components: {
    selectProduct,
    importTemplate
  },
  data() {
    return {
      queryForm: {
        salesman: {
          submitName: "salesman",
          selected: {},
          valueIsObj: true,
          isMultiple: false,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          list: [],
          placeholder: "请选择业务员",
          request: {
            url: "/Account/userDefine/selectUserListForVue.html",
            type: "post",
            params: { page: 1, size: 10 },
            text: "",
            value: "",
          },
        },
        deliverUser: {
          submitName: "deliverUser",
          selected: {},
          valueIsObj: true,
          isMultiple: false,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          list: [],
          placeholder: "请选择盘点人",
          request: {
            url: "/Account/userDefine/selectUserListForVue.html",
            type: "post",
            params: { page: 1, size: 10 },
            text: "",
            value: "",
          },
        },
        inWarehouse: {
          submitName: "warehouse",
          selected: {},
          valueIsObj: true,
          isMultiple: false,
          isAll: false,
          isShowAll: false,
          isFilterable: true,
          isRemote: true,
          isPagination: true,
          isReSearch: false,
          isDisabled: false,
          list: [],
          placeholder: "请选择仓库",
          request: {
            url: "/Account/wareHouseDefine/selectWarehouseFreezeForAuth.html",
            type: "post",
            params: { page: 1, size: 10, billType: 'PKD' },
            text: "",
            value: "",
          },
        },
        remark: {
          submitName: "remark",
          selected: "",
          placeholder: "请输入备注",
        },
      },
      selectProductVisible: false,
      selectProductList: [],
      defaultCheckedKeys: [],
      defaultDisabledKeys: [],
      isCanEnter: false,
      searchInput: '',
      dialogImportVisible: false,
      empty: 'C',
      searchType: ''
    };
  },
  created() {},
  mounted () {
    $(this.$refs.inWarehouse.$el).find('input').click(this.selectClick)
    console.log(this.billNo)
    if(this.billNo) return
    this.$refs.inWarehouse.$children[0].focus()
  },
  computed: {
    queryItem () {
      let tempItem = {}
      Object.values(this.queryForm).forEach(item => {
        tempItem[item.submitName] = item.selected
      })
      return tempItem
    }
  },
  methods: {
    queryFormLeftOrRight(selfRef, nextOrPrevRef) {
      queryFormLeftOrRight(selfRef, nextOrPrevRef)
    },
    async inWarehouseSelect () {
      this.$emit('getQueryForm', this.queryItem)
      this.isCanEnter = false
      const loading = this.$loading({
        lock: true,
        text: '查询当前库房状态中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.2)'
      });
      const { data: res } = await this.$http.post('/Account/InvCheckVue/selectWareHouseFreezeStatus.html', this.Qs.stringify({ warehouseID: this.queryForm.inWarehouse.selected.value }))
      loading.close()
      if (res.code != 'success') return this.$message.error(res.message)
      let { freezeInfo, isHaveUnCheckBill } = JSON.parse(JSON.parse(res.result).data)
      if (isHaveUnCheckBill == 'N') {
        // const confirmResult = await this.$confirm('当前库房未冻结, 是否冻结?', '提示', {
        //     confirmButtonText: '是',
        //     cancelButtonText: '否',
        //     type: 'warning'
        // }).catch(err => err)
        // if (confirmResult == 'confirm') {
        //   const { data: result } = await this.$http.post('/Account/InvCheckVue/updateWareHouseIsFreezed.html', this.Qs.stringify({ warehouseID: this.queryForm.inWarehouse.selected.value }))
        //   if (result.code != 'success') return this.$message.error(result.message)
        //   this.$message.success(result.message)
        // }
        this.isCanEnter = true
        this.$refs.inWarehouse.$children[0].blur()
        this.$refs.salesman.$children[0].focus()
      } else if (isHaveUnCheckBill == 'Y') {
        this.$confirm(freezeInfo, '提示', {
          confirmButtonText: '确定',
          showCancelButton: false,
          type: 'warning'
        }).catch(err => err)
      }
      this.$nextTick(() => {
        let $table = this.$parent.$children[1]
        $table.tableData = $table.pushItem()
        this.selectProductList = []
        this.defaultCheckedKeys = []
        this.$emit('resetCascaderMultiple')
      })
    },
    salesmanSelect () {
      this.$emit('getQueryForm', this.queryItem)
      this.$refs.salesman.$children[0].blur()
      this.$refs.deliverUser.$children[0].focus()
    },
    deliverUserSelect () {
      this.$emit('getQueryForm', this.queryItem)
      this.$nextTick(() => {
        this.$refs.deliverUser.$children[0].blur()
        this.$refs.remark.focus()
      })
    },
    remarkChange() {
      try {
        this.$parent.$children[1].getProductData()
      } catch (error) {
        console.log(error);
      }
      this.$emit('getQueryForm', this.queryItem)
    },
    async beginInventory (command) {
      if (!this.queryForm.inWarehouse.selected.value) return this.$message({
        showClose: true,
        message: '请先选择仓库',
        type: 'warning'
      })
      this.dropdownCommand = command
      this.$nextTick(() => {
        this.$parent.$children[1].clearTable()
        this.selectProductList = []
        if (command == 'C') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.getProductAllData(2)
        } else if (command == 'D') {
          this.empty = 'D'
          this.$emit('setEmpty', 'D')
          this.getProductAllData(1)
        } else if (command == 'E') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.dialogImportVisible = true
        } else if (command == 'F') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.getProductAllDataNew('A')
        } else if (command == 'G') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.getProductAllDataNew('B')
        } else if (command == 'H') {
          this.empty = 'D'
          this.$emit('setEmpty', 'D')
          this.getProductAllDataNew('C')
        } else if (command == 'I') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.searchType = 'A'
          this.dialogImportVisible = true
        } else if (command == 'J') {
          this.empty = 'C'
          this.$emit('setEmpty', 'C')
          this.searchType = 'B'
          this.dialogImportVisible = true
        }
      })
    },
    getProductAllData (searchType) {
      this.$nextTick(async () => {
        let $table = this.$parent.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$http.post('/Account/dataSearchVue/selectItemEnterDetailList.html', this.Qs.stringify({
          warehouseID: this.queryForm.inWarehouse.selected.value,
          searchType,
          billType: 'PKD'
        }))
        if (res.code != "success") return this.$message.error(res.message);
        res.result = JSON.parse(res.result);
        const result = await $table.addProductToOrder(JSON.parse(res.result.data))
        $table.computedInventory()
        if (result) $table.tableLoading = false
      })
    },
    getProductAllDataNew (searchType) {
      this.$nextTick(async () => {
        let $table = this.$parent.$children[1]
        $table.tableLoading = true
        const { data: res } = await this.$post('/erpnew/account/c/reada46ceb/select/inventoryItem', {
          warehouseID: this.queryForm.inWarehouse.selected.value,
          searchType
        })
        if (res.code != "0") return this.$message.error(res.message);
        const result = await $table.addProductToOrder(res.data)
        $table.computedInventory()
        if (result) $table.tableLoading = false
      })
    },
    batchEnterInventory () {
      if (this.power.activeName == 'third' && this.empty == 'D') return this.$message({
        showClose: true,
        message: '盘空单暂不支持批量录入',
        type: 'warning'
      })
      if (!this.queryForm.inWarehouse.selected.value) return this.$message({
        showClose: true,
        message: '请先选择仓库',
        type: 'warning'
      })
      if (!this.isCanEnter) return this.$message({
        showClose: true,
        message: '请先审核其他盘点单',
        type: 'warning'
      })
      this.selectProductVisible = true
      this.defaultCheckedKeys = this.$parent.$children[1]?.tableData?.filter(i => Boolean(i.itemID)).map(i => {
        i['text'] = i['itemName']
        i['value'] = i['itemID']
        return i
      })
    },
    async getProductData (data) {
      this.selectProductVisible = false
      let $table = this.$parent.$children[1]
      const keys = (i) => {
        return i.itemID + i.productionDate
      }
      $table.tableLoading = true
      let add = getResultArray(keys, 'd', data, this.selectProductList)
      let detele = getResultArray(keys, 'd', this.selectProductList, data)
      console.log({ add, detele })
      if (add.length) {
        this.selectProductList = this.selectProductList.concat(add)
        const res = await $table.addProductToOrder(add)
        if (res) $table.tableLoading = false
      } 
      if (detele.length) {
        detele.forEach(item => {
          this.selectProductList = this.selectProductList.filter(i => keys(i) != keys(item))
        })
        const res = await $table.deleteProductToOrder('', '', detele)
        if (res) $table.tableLoading = false
      }
      if (add.length == 0 && detele.length == 0) {
        $table.tableLoading = false
      }
    },
    tableFilter () {
      this.$nextTick(() => {
        this.$parent.$children[1].tableFilter(this.searchInput)
      })
    },
    toJump () {
      let width = window.top.document.browser.availiframeWidth.value
      let height = window.top.document.browser.availiframeHeight.value
      top.addPanel('订单占用查询', `/templates/vue-account/dist/index.htm#/orderOccupy`, width, height, true)
      // this.$router.push('/orderOccupy')
    },
    selectClick () {
      this.$nextTick(async () => {
        if (this.$parent.$children[1].tableData.filter(i => i.itemID).length) {
          const confirmResult = await this.$confirm('您已录入商品，此操作将删除所以表格数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).catch(err => err)
          if (confirmResult !== 'confirm') {
            this.$refs['inWarehouse'].$children[0].blur()
            return
          }
        }
      })
    },
    dialogImportColse () {

    }
  },
};
</script>

<style scoped lang="less">
.query-card {
  ::v-deep .el-card__body {
    padding: 12px;
    .query_form {
      position: relative;
      display: flex;
      .el-form-item {
        margin-bottom: 0;
        .el-form-item__label {
          position: absolute;
          z-index: 2;
          top: -12px;
          margin-left: 10px;
          padding: 0 6px;
          background-color: #fff;
          line-height: normal;
          font-family: "Helvetica Neue";
          font-size: 12px;
        }
        .query_form_item {
          position: relative;
          flex: 1;
        }
      }
    }
  }
  ::v-deep .el-dialog {
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 10px 20px 0 10px;
    }
    .el-dialog__footer {
      padding: 5px 15px 10px;
      text-align: right;
    }
  }
  ::v-deep .warehouse-dialog {
    .el-dialog__body {
      text-align: center;
    }
  }
}
</style>
